<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-data-table
      class="elevation-2"
      :headers="headers"
      :loading="loading"
      :items="programs"
      disable-pagination
      hide-default-footer
    >
      <template
        v-if="$vuetify.breakpoint.xs"
        #[`item.title`]="{item}"
      >
        <span>{{ item.title }}</span>
      </template>
      <template
        v-if="$vuetify.breakpoint.xs"
        #[`item.total_views`]="{item}"
      >
        <span>{{ item.total_views }}名</span>
      </template>
      <template
        v-if="$vuetify.breakpoint.xs"
        #[`item.active_views`]="{item}"
      >
        <span>{{ item.active_views }}名</span>
      </template>
      <template
        v-if="$vuetify.breakpoint.xs"
        #[`item.remaining_views`]="{item}"
      >
        <span>{{ item.remaining_views }}名</span>
      </template>
      <template
        v-if="$vuetify.breakpoint.smAndUp"
        #item="i"
      >
        <tr>
          <td class="text-subtitle-1 font-weight-bold">
            {{ i.item.title }}
          </td>
          <td class="text-subtitle-1 font-weight-bold text-center">
            {{ i.item.total_views }}{{ $i18n.locale === 'jp' ? '名' : '' }}
          </td>
          <td class="text-subtitle-1 font-weight-bold text-center">
            {{ i.item.active_views }}{{ $i18n.locale === 'jp' ? '名' : '' }}
          </td>
          <td
            class="accent3 text-subtitle-1 font-weight-bold text-center"
          >
            {{ i.item.remaining_views }}{{ $i18n.locale === 'jp' ? '名' : '' }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>

export default {
  props: {
    programs: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      currentCompanyPrograms: [],
      allPrograms: [],
    }
  },
  computed: {
    /**
     * @desc to compute the headers for the datatable
     */
    headers() {
      return [
        { text: this.$t('program_list_table.video_content_name'), align: 'center', divider: true, value: 'title', sortable: true, width: '250px', class: 'primary white--text' },
        { text: this.$t('program_list_table.total_view'), align: 'center', divider: true, value: 'total_views', sortable: true, width: '200px', class: 'primary white--text' },
        { text: this.$t('program_list_table.assigned_view'), align: 'center', divider: true, value: 'active_views', sortable: true, width: '180px', class: 'primary white--text' },
        { text: this.$t('program_list_table.remaining_view'), align: 'center', divider: true, value: 'remaining_views', sortable: true, width: '160px', class: 'primary white--text' }
      ]
    }
  },
}
</script>
<style scoped>
::v-deep .v-data-table__mobile-row__header {
  width: 50%;
}
::v-deep .v-data-table__mobile-row__cell {
  width: 50%;
}
::v-deep .theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  color: white;
}
th:not(:last-child), td:not(:last-child) {
  border-right: 1px solid #e0e0e0;
}
</style>
